import { Carrier } from './carrier.model';
import * as moment from 'moment';
import { Subcontractor } from './subcontractor.model';
import { BlockDetails } from './block-details';
import { Region } from './region.model';
import { LocalLocationContainerLight } from '../../local-loads/shared/local-location-container-light.model';

export class UserInfo {

  public id: string;
  public email: string;
  public password: string;
  public createDate: string;
  public createDateTimestamp: number;
  public updateDate: string;
  public updateDateTimestamp: number;
  public lastLogin: string;
  public lastLoginTimestamp: number;
  public blocked: boolean;
  public verified: boolean;
  public carrier: Carrier;
  public bluechatId: string;
  public subcontractor: Subcontractor;
  public blockDetails: BlockDetails[] = [];
  public allowedRegions: string[]     = [];
  public allowedPlants: string[]      = [];

  public regions: Region[]                     = [];
  public plants: LocalLocationContainerLight[] = [];

  public selected = false;
  public externalIdpConnectionEnabled

  static fromDto(u: any): UserInfo {
    if (!u) {
      return null;
    }

    const user = new UserInfo();

    user.id       = u.id;
    user.email    = u.email;
    user.password = u.password;

    user.createDate          = u.createDate;
    user.createDateTimestamp = u.createDate ? moment(u.createDate).valueOf() : null;

    user.updateDate          = u.updateDate;
    user.updateDateTimestamp = u.updateDate ? moment(u.updateDate).valueOf() : null;

    user.lastLogin          = u.lastLogin;
    user.lastLoginTimestamp = u.lastLogin ? moment(u.lastLogin).valueOf() : null;

    user.blocked        = u.blocked;
    user.verified       = u.verified;
    user.carrier        = Carrier.fromDto(u.carrier);
    user.subcontractor  = Subcontractor.fromDto(u.subcontractor);
    user.blockDetails   = u.blockDetails || [];
    user.allowedRegions = u.allowedRegions;
    user.allowedPlants  = u.allowedPlants;
    user.bluechatId     = u.bluechatId;

    user.externalIdpConnectionEnabled = u.externalIdpConnectionEnabled

    return user;
  }

  static toDto(u: UserInfo): any {
    if (!u) {
      return null;
    }

    const carrier       = u.carrier ? { id: u.carrier.id } : null;
    const subcontractor = u.subcontractor ? { id: u.subcontractor.id } : null;

    return {
      id: u.id,
      email: u.email,
      password: u.password,
      createDate: u.createDate,
      updateDate: u.updateDate,
      lastLogin: u.lastLogin,
      blocked: u.blocked,
      verified: u.verified,
      carrier: carrier,
      subcontractor: subcontractor,
      allowedRegions: u.allowedRegions,
      allowedPlants: u.allowedPlants,
      bluechatId: u.bluechatId
    };
  }

  bluechatEnabled(): boolean {
    return this.bluechatId && this.bluechatId.trim() !== '';
  }
}
